import { init, makeFetchTransport, ModuleMetadata, BrowserTracing, makeMultiplexedTransport } from '@sentry/browser';
import { CONFIG } from 'config';


export const logger = () => {
  const EXTRA_KEY = 'ROUTE_TO';

  const transport = makeMultiplexedTransport(makeFetchTransport, (args) => {
    const event = args.getEvent();
    if (
      event &&
      event.extra &&
      EXTRA_KEY in event.extra &&
      Array.isArray(event.extra[EXTRA_KEY])
    ) {
      return event.extra[EXTRA_KEY];
    }
    return [];
  });

  init({
    transport,
    dsn: CONFIG.SENTRY_DSN,
    tracesSampleRate: 0.01,
    environment: CONFIG.SENTRY_ENVIRONMENT,
    integrations: [new ModuleMetadata(), new BrowserTracing()],
    beforeSend: (event) => {
      //@ts-ignore
      if (event?.exception?.values?.[0]?.stacktrace?.frames) {
        const frames = event.exception.values[0].stacktrace.frames;
        // Find the last frame with module metadata containing a DSN
        const routeTo = frames
          .filter((frame) => frame.module_metadata && frame.module_metadata.dsn)
          .map((v) => v.module_metadata)
          .slice(-1); // using top frame only - you may want to customize this according to your needs

        if (routeTo.length) {
          event.extra = {
            ...event.extra,
            [EXTRA_KEY]: routeTo,
          };
        }
      } else if (event.tags?.dsn) {
        event.extra = {
          ...event.extra,
          [EXTRA_KEY]: [{ dsn: event.tags.dsn, release: event.tags.release }],
        };
      }
  
      return event;
    },
  });
};